// Single source of truth for the BCS subject-guideline pages.
// Add a new guideline here and it automatically shows up in the
// GuidelineNav switcher, the GuidelineRelated cards and GuidelinesPage hub.
import { URLs } from "@/static";

export const guidelines = [
  {
    key: 'bangla',
    short: 'বাংলা',
    title: 'বিসিএস বাংলা গাইডলাইন',
    desc: 'বাংলা ভাষা ও সাহিত্যের সম্পূর্ণ হিটম্যাপ বিশ্লেষণ, ৩৬ জন গুরুত্বপূর্ণ সাহিত্যিক, প্রতিটি টপিকের গুরুত্ব র‍্যাংকিং।',
    image: require('@/assets/blogs/bangla_guideline_banner.png'),
    route: URLs.ROUTE_BANGLA_GUIDELINE_NAME,
    marks: '৩০ মার্ক',
    tags: ['বাংলা ভাষা', 'বাংলা সাহিত্য'],
  },
  {
    key: 'english',
    short: 'ইংরেজি',
    title: 'বিসিএস ইংরেজি গাইডলাইন',
    desc: 'English Language ও Literature-এর হিটম্যাপ, গুরুত্বপূর্ণ লেখক ও Literary Terms সহ সম্পূর্ণ অধ্যয়ন গাইড।',
    image: require('@/assets/blogs/english_guideline_banner.png'),
    route: URLs.ROUTE_ENGLISH_GUIDELINE_NAME,
    marks: '৩০ মার্ক',
    tags: ['English Language', 'English Literature'],
  },
  {
    key: 'bangladesh',
    short: 'বাংলাদেশ বিষয়াবলি',
    title: 'বাংলাদেশ বিষয়াবলি গাইডলাইন',
    desc: 'ইতিহাস, সংবিধান, অর্থনীতি ও সাম্প্রতিক বাংলাদেশের সম্পূর্ণ টপিকভিত্তিক হিটম্যাপ ও মার্ক বিভাজন।',
    image: require('@/assets/blogs/bangladesh_guideline_banner.png'),
    route: URLs.ROUTE_BANGLADESH_GUIDELINE_NAME,
    marks: '২৫ মার্ক',
    tags: ['ইতিহাস', 'সংবিধান', 'মুক্তিযুদ্ধ', 'অর্থনীতি', 'সাম্প্রতিক'],
  },
  {
    key: 'international',
    short: 'আন্তর্জাতিক বিষয়াবলি',
    title: 'আন্তর্জাতিক বিষয়াবলি গাইডলাইন',
    desc: 'আন্তর্জাতিক সংগঠন, নিরাপত্তা, পরিবেশ ইস্যু ও ভূ-রাজনীতির সম্পূর্ণ টপিকভিত্তিক হিটম্যাপ ও মার্ক বিভাজন (৩৫–৫০ বিসিএস)।',
    image: require('@/assets/blogs/international_guideline_banner.png'),
    route: URLs.ROUTE_INTERNATIONAL_GUIDELINE_NAME,
    marks: '২৫ মার্ক',
    tags: ['আন্তর্জাতিক সংগঠন', 'নিরাপত্তা', 'পরিবেশ ইস্যু', 'ভূ-রাজনীতি', 'সাম্প্রতিক'],
  },
  {
    key: 'ict',
    short: 'কম্পিউটার ও আইসিটি',
    title: 'কম্পিউটার ও তথ্যপ্রযুক্তি গাইডলাইন',
    desc: 'কম্পিউটার অঙ্গসংগঠন, নেটওয়ার্ক, ইন্টারনেট ও আধুনিক প্রযুক্তির সম্পূর্ণ টপিকভিত্তিক হিটম্যাপ ও মার্ক বিভাজন (৩৫–৫০ বিসিএস)।',
    image: require('@/assets/blogs/ict_guideline_banner.png'),
    route: URLs.ROUTE_ICT_GUIDELINE_NAME,
    marks: '১৫ মার্ক',
    tags: ['কম্পিউটার', 'নেটওয়ার্ক', 'ইন্টারনেট', 'আধুনিক প্রযুক্তি'],
  },
  {
    key: 'science',
    short: 'সাধারণ বিজ্ঞান',
    title: 'সাধারণ বিজ্ঞান গাইডলাইন',
    desc: 'ভৌত বিজ্ঞান, জীববিজ্ঞান ও আধুনিক বিজ্ঞানের সম্পূর্ণ টপিকভিত্তিক হিটম্যাপ ও মার্ক বিভাজন (৩৫–৫০ বিসিএস)।',
    image: require('@/assets/blogs/science_guideline_banner.png'),
    route: URLs.ROUTE_SCIENCE_GUIDELINE_NAME,
    marks: '১৫ মার্ক',
    tags: ['ভৌত বিজ্ঞান', 'জীববিজ্ঞান', 'আধুনিক বিজ্ঞান', 'রসায়ন'],
  },
  {
    key: 'geography',
    short: 'ভূগোল ও পরিবেশ',
    title: 'ভূগোল ও পরিবেশ গাইডলাইন',
    desc: 'বাংলাদেশ ও বিশ্বের ভৌগলিক অবস্থান, ভূমিরূপ, প্রাকৃতিক দুর্যোগ, প্রকৃতি-সম্পদ ও পরিবেশ পরিবর্তনের সম্পূর্ণ সিলেবাসভিত্তিক গাইডলাইন।',
    image: require('@/assets/blogs/geography_guideline_banner.png'),
    route: URLs.ROUTE_GEOGRAPHY_GUIDELINE_NAME,
    marks: '১০ মার্ক',
    tags: ['ভৌগলিক অবস্থান', 'ভূমিরূপ', 'দুর্যোগ', 'পরিবেশ', 'জলবায়ু'],
  },
  {
    key: 'math',
    short: 'গণিত ও মানসিক দক্ষতা',
    title: 'গাণিতিক যুক্তি ও মানসিক দক্ষতা গাইডলাইন',
    desc: 'গাণিতিক যুক্তি ও মানসিক দক্ষতার একুরেট টপিকভিত্তিক প্রশ্ন হিটম্যাপ, গুরুত্বপূর্ণ টপিক র‍্যাংকিং ও মার্ক বিভাজন (৩৫–৫০ বিসিএস)।',
    image: require('@/assets/blogs/math_guideline_banner.png'),
    route: URLs.ROUTE_MATH_GUIDELINE_NAME,
    marks: '৩৫ মার্ক',
    tags: ['গাণিতিক যুক্তি', 'মানসিক দক্ষতা', 'বীজগণিত', 'জ্যামিতি', 'বিন্যাস ও সমাবেশ'],
  },
];

export const guidelinesHubName = URLs.ROUTE_GUIDELINES_NAME;